import { useBasicABTest } from '@bridebook/web/app-basic/lib/ab-tests/hooks/use-basic-ab-test';
import { LandingPagesTests } from '@bridebook/web/app-basic/lib/ab-tests/tests/landing-pages-tests';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { LandingServerSideProps } from '@bridebook/web/pages/[market]/basic/landing/[id]';

/**
 * Returns either control or variant version of HTML content of a given landing page.
 */
export const useLandingPageABTest = ({
  html: controlHtml,
  pageVariants,
  pageId,
}: LandingServerSideProps) => {
  const market = useMarket();
  const abTest = LandingPagesTests[pageId];

  // Activate test only if there is no `markets` property or `markets` contains the current market
  const triggerCondition = Boolean(
    abTest?.testId && (!abTest?.markets || abTest.markets.includes(market.country)),
  );

  const { variant } = useBasicABTest(abTest?.testId || '', triggerCondition);

  return pageVariants?.htmlVariants[variant] || controlHtml;
};
